enum Role {
  BASIC = 'Basic',
  MANAGER = 'Manager',
  ADMIN = 'Admin',
  SUBSCRIPTION_MANAGER = 'SubscriptionManager',
}

export default Role;
